import { render } from "./Dashboard.vue?vue&type=template&id=08958bfe&scoped=true&bindings={\"user\":\"options\",\"workspaces\":\"options\",\"maintenanceMode\":\"options\",\"getWorkspaceName\":\"options\",\"goToWorkspaceSettings\":\"options\",\"openCreateNewWorkspace\":\"options\"}"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=08958bfe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08958bfe"

export default script